import './App.css';
import { Route, Routes, BrowserRouter, HashRouter } from "react-router-dom";
import Homepage from './components/home.component';
import QuoteForm from './components/form.component';
import DemoPage from './components/demo.component';


function App() {
  return (
    <div >
      <HashRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/quote" element={<QuoteForm />} />
          <Route path="/demo" element={<DemoPage />} />
        </Routes>
      </HashRouter>
    </div>
  );
}

export default App;
